import React from 'react'

type Props = {
    fillColor: string;
}

const GraphShadowIcon = ({ fillColor }: Props) => {
    const maskStyle: React.CSSProperties = {
        maskType: 'alpha',
    };

    return (
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="53" viewBox="0 0 80 53" fill="none">
                <mask id="mask0_14927_5456" style={maskStyle} maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="53">
                    <rect width="80" height="53" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_14927_5456)">
                    <path d="M11.1364 33.1021L0 52H81V1L65.7048 7.56436L57.9093 21.3547L33.4092 22.887L23.3865 36.6774L11.1364 33.1021Z" fill="url(#paint0_linear_14927_5456)" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M65.8366 8.20741L81 1.78447L82.5 0.5L64.0038 6.73293L56.2143 20.333L31.4213 21.8634L21.4298 35.4315L8.90573 31.8239L-2.87433 51.5534C-3.17051 52.0494 -2.92528 52.6505 -2.3266 52.8959C-1.72792 53.1413 -1.00249 52.9381 -0.706312 52.4421L10.1274 34.2976L22.4784 37.8553L32.8393 23.7856L57.7965 22.2451L65.8366 8.20741Z" fill={fillColor} />
                </g>
                <defs>
                    <linearGradient id="paint0_linear_14927_5456" x1="14.5" y1="-6" x2="40.5" y2="52" gradientUnits="userSpaceOnUse">
                        <stop offset="0.232779" stopColor={fillColor} stopOpacity="0.28" />
                        <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />
                    </linearGradient>
                </defs>
            </svg>
        </div>
    )
}

export default GraphShadowIcon